<template>
  <div class="header" v-if="show">
    <div class="header-left">
      <a @click="$parent.goNav('/app')" class="header-download"></a>
    </div>
    <div class="header-center">
      <a @click="$parent.goNav('/')" class="header-logo">          <img  :src="$store.state.appInfo.site_logo || '/static/image/d11_logo_h5.png'" onerror="this.src = '/static/image/d11_logo_h5.png'" width="100%" />
      </a>
      <h4 class="header-title hide"></h4>
    </div>
    <div class="header-right">
      <a id="gocs_btn" @click="$parent.openKefu" class="header-helper"></a>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Header',
  data() {
    return { bankShow: false, show: true };
  },
  created() {
    let that = this;
    // that.uservip();
  },
  methods: {
    transall() {
      let that = this;
      that.$parent.showLoading();
      that.$apiFun
        .post('/api/transall', {})
        .then(res => {
          that.$parent.showTost(0, res.message);
          that.$parent.getUserInfoShowLoding();
          that.$parent.hideLoading();
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
    changPath() {
      let that = this;
      let path = this.$route.path;
   
    
     
     
      if (path == '/' || path == '/activity' ) {
        that.show = true;
      }else{
        that.show = false;
        
      }

     
    },
  },
  updated() {
    let that = this;
  },
  mounted() {},
  watch: {
    //监听路由地址的改变
    $route: {
      immediate: true,
      handler() {
        let that = this;
        that.changPath();
      },
    },
  },
};
</script>
<style lang="scss" scoped>
// @import '../../../static/css/chunk-b7675268.a1b3941c.css';
</style>



// WEBPACK FOOTER //
// src/components/libs/Header.vue